import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Sonner } from './components/sonner'
import './index.css'
import { store } from './redux/global-store'
import { Router } from './router/router'
import { initializeUniversalInterceptors } from './config/universal-interceptor'

// Inicializa o interceptador universal para capturar erros 401
initializeUniversalInterceptors()

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <Sonner />
    <Router />
  </Provider>,
)
